import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  preMerge: {
    id: 'frontbucket.settings.merge-checks.preMerge',
    description: 'Label for a custom merge check that runs pre-merge',
    defaultMessage: 'pre-merge',
  },
  onMerge: {
    id: 'frontbucket.settings.merge-checks.onMerge',
    description: 'Label for a custom merge check that runs on-merge',
    defaultMessage: 'on-merge',
  },
  enableErrorMessage: {
    id: 'frontbucket.settings.merge-checks.enableErrorMessage',
    description: 'Error message for flag when enable check failed',
    defaultMessage: 'Something went wrong while trying to enable "{name}"',
  },
  disableErrorMessage: {
    id: 'frontbucket.settings.merge-checks.disableErrorMessage',
    description: 'Error message for flag when disable check failed',
    defaultMessage: 'Something went wrong while trying to disable "{name}"',
  },
  checkDisabledLabel: {
    id: 'frontbucket.settings.merge-checks.checkDisabledLabel',
    description: 'Label for custom merge check when it is disabled',
    defaultMessage: 'Off',
  },
  checkRecommendedLabel: {
    id: 'frontbucket.settings.merge-checks.checkRecommendedLabel',
    description:
      'Label for custom merge check when it is recommended, i.e. cannot block a merge',
    defaultMessage: 'Recommended',
  },
  checkRequiredLabel: {
    id: 'frontbucket.settings.merge-checks.checkRequiredLabel',
    description:
      'Label for custom merge check when it is required, i.e. can block a merge',
    defaultMessage: 'Required',
  },
  checkNotRequiredLabel: {
    id: 'frontbucket.settings.merge-checks.checkNotRequiredLabel.non-final',
    description:
      'Label for custom merge check when it is not required, i.e. does not block a merge',
    defaultMessage: 'Not required',
  },
  requiredPremiumOnly: {
    id: 'frontbucket.settings.merge-checks.premiumRequired',
    description:
      'Explains that the "Required" option for checks is only available to premium workspaces',
    defaultMessage: 'Required is only available to premium workspaces',
  },
  premiumIconLabel: {
    id: 'frontbucket.settings.merge-checks.premiumIconLabel',
    description:
      'Accessibility label for Premium icon that indicates a feature is only available to premium workspaces',
    defaultMessage: 'Premium workspaces only',
  },
  mergeChecksPremiumDescription: {
    id: 'frontbucket.settings.merge-checks.mergeChecksPremiumDescription.non-final',
    description:
      'Description of which custom merge check features are limited to premium workspaces',
    defaultMessage:
      'Preventing merges with unresolved custom merge checks, and defining custom merge checks in workspace and project settings are premium features.',
  },
  upgradeToPremium: {
    id: 'frontbucket.settings.merge-checks.upgradeToPremium.non-final',
    description: 'Label for button to upgrade workspace to premium',
    defaultMessage: 'Upgrade to premium',
  },
  addCheck: {
    id: 'frontbucket.settings.merge-checks.addCheck.non-final',
    description: 'Label for button to add a check',
    defaultMessage: 'Add check',
  },
  editCheck: {
    id: 'frontbucket.settings.merge-checks.editCheck.non-final',
    description: 'Label for button to edit a check',
    defaultMessage: 'Edit',
  },
  deleteCheck: {
    id: 'frontbucket.settings.merge-checks.deleteCheck.non-final',
    description: 'Label for button to delete a check',
    defaultMessage: 'Delete',
  },
  allBranches: {
    id: 'frontbucket.settings.merge-checks.allBranches.non-final',
    description: 'Label for the "all branches" configuration value',
    defaultMessage: 'All branches',
  },
  mainBranch: {
    id: 'frontbucket.settings.merge-checks.mainBranch.non-final',
    description: 'Label for the "main branch" configuration value',
    defaultMessage: 'Main branch',
  },
  inheritedFromProject: {
    id: 'frontbucket.settings.merge-checks.inheritedFromProject.non-final',
    description:
      'Label for check configurations that are inherited from project settings',
    defaultMessage: 'Inherited from project settings',
  },
  inheritedFromWorkspace: {
    id: 'frontbucket.settings.merge-checks.inheritedFromWorkspace.non-final',
    description:
      'Label for check configurations that are inherited from workspace settings',
    defaultMessage: 'Inherited from workspace settings',
  },
  name: {
    id: 'frontbucket.settings.merge-checks.name.non-final',
    description: 'Label for column containing the check name',
    defaultMessage: 'Name',
  },
  branch: {
    id: 'frontbucket.settings.merge-checks.branch.non-final',
    description: 'Label for column containing the check branch configuration',
    defaultMessage: 'Branch',
  },
  enforcement: {
    id: 'frontbucket.settings.merge-checks.enforcement.non-final',
    description:
      'Label for column containing the check enforcement value, i.e. "Required" or "Not required"',
    defaultMessage: 'Enforcement',
  },
  actions: {
    id: 'frontbucket.settings.merge-checks.actions.non-final',
    description: 'Label for column containing actions to perform on a check',
    defaultMessage: 'Actions',
  },
});
